import { RTC_PROTOCOL_V1 } from '../protocol/constants.js';
import { sha256 } from '../util/sha256.js';
import { base64EncodeUnpadded, canonicalJsonStringArray, utf8Encode } from '../util/encoding.js';
export const livekitIdentity = (userId, deviceId) => `${userId}:${deviceId}`;
export const memberIdFor = (userId, deviceId) => livekitIdentity(userId, deviceId);
export const parseLivekitIdentity = (identity) => {
    if (!identity.startsWith('@')) {
        return undefined;
    }
    const separator = identity.lastIndexOf(':');
    const serverSeparator = identity.indexOf(':');
    if (separator <= 0 || separator === serverSeparator || separator === identity.length - 1) {
        return undefined;
    }
    return { userId: identity.slice(0, separator), deviceId: identity.slice(separator + 1) };
};
export const membershipStateKey = (userId, deviceId) => `_${userId}_${deviceId}_m.call`;
export const hashedRoomName = (roomId, slotId = RTC_PROTOCOL_V1.slotId) => base64EncodeUnpadded(sha256(utf8Encode(canonicalJsonStringArray([roomId, slotId]))));
export const hashedParticipantIdentity = (sender, memberId) => base64EncodeUnpadded(sha256(utf8Encode(canonicalJsonStringArray([sender, memberId]))));
export const serverNameOf = (userId) => {
    const index = userId.indexOf(':');
    return index > 0 && index < userId.length - 1 ? userId.slice(index + 1) : undefined;
};
